import React from 'react'
import { isMobile } from 'react-device-detect'

import { CompactTable } from '@table-library/react-table-library/compact'
import { useTheme } from '@table-library/react-table-library/theme'

const ReceiptsTable = ({ data = [], columns = [] }) => {

  // needs id as a prop
  data = data.map(v => { v.id = v._id; return v })

  const tableData = {
    nodes: data,
  }

  const tableTheme = useTheme(
    [
      {
        Table: `
          --data-table-library_grid-template-columns: 
            minmax(6rem, 1fr) // Quantity
            minmax(18rem, 1fr) // Description
            minmax(6rem, 1fr) // Billing
            minmax(7rem, 1fr) // Payment
            minmax(10rem, 1fr) // Amount in USD
            minmax(10rem, 1fr) // Coupon Applied
            minmax(9rem, 1fr) // Purchased On
            minmax(4rem, 1fr) // Type
            minmax(12rem, 1fr) // Plan Id
            minmax(14rem, 1fr) // Payee Info
            minmax(15rem, 1fr) // Payee Address
            minmax(7rem, 1fr); // Download

          grid-template-rows: max-content;

          height: 100%;
        `,
        HeaderCell: `
          height: fit-content;
          border-top: 1px solid #dee2e6;
          border-left: 0.5px solid #dee2e6;
          :last-of-type {
            border-right: 1px solid #dee2e6;
          }
          color: #4c4c4c !important;
      `,
        Row: `
          font-size:15px;
          .td {
          border-bottom: 1px solid #dee2e6;
          border-left: 1px solid #dee2e6;
        }
      `,
        BaseCell: `
          .td {
            border-left: 1px solid #dee2e6;
          }
      `,
        Cell: `
          text-wrap:auto;
          :last-of-type {
            border-right: 1px solid #dee2e6;
          }
      `
      }
    ]
  )

  return (
    <div className='receipt-list-table'>
      <CompactTable
        columns={columns}
        data={tableData}
        layout={{
          fixedHeader: true,
          horizontalScroll: !isMobile,
          custom: true
        }}
        theme={tableTheme}
      />
    </div>
  )
}

export default ReceiptsTable